import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Order/RequestBonusCardBlock/RequestBonusCard/requestBonusCardBlock.container"
    ).then((module) => ({
        default: module.RequestBonusCardBlock
    }))
);
